import { render, staticRenderFns } from "./ProductSpecsCreate.vue?vue&type=template&id=64cacaeb"
import script from "./ProductSpecsCreate.vue?vue&type=script&lang=js"
export * from "./ProductSpecsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64cacaeb')) {
      api.createRecord('64cacaeb', component.options)
    } else {
      api.reload('64cacaeb', component.options)
    }
    module.hot.accept("./ProductSpecsCreate.vue?vue&type=template&id=64cacaeb", function () {
      api.rerender('64cacaeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productSpecs/ProductSpecsCreate.vue"
export default component.exports